import type { PropsWithChildren } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { Sidebar } from './Sidebar';
import { useUi } from '@/store/uiStore';

export function AppShell({ children }: PropsWithChildren) {
  const toast = useUi((s) => s.toast);
  const setMobileMenuOpen = useUi((s) => s.setMobileMenuOpen);
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isReader = pathname.startsWith('/read/');

  return (
    <div className="app-shell">
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <Sidebar />
      <div id="main">
        {!isReader && (
          <header className="mobile-page-bar" aria-label="Menu">
            <button
              type="button"
              className="menu-button"
              onClick={() => setMobileMenuOpen(true)}
              aria-label="Open menu"
            >
              <span aria-hidden style={{ fontSize: '1.25rem', lineHeight: 1 }}>☰</span>
            </button>
          </header>
        )}
        {children}
      </div>
      {toast && <div className="toast">{toast.text}</div>}
    </div>
  );
}
